import { BaseResponseVO } from "./base-responseVO";


export class ResultListVO<T> extends BaseResponseVO {
    resultList: Array<T>;
}